import { render, staticRenderFns } from "./CitySelect.vue?vue&type=template&id=a15605c2&scoped=true&"
import script from "./CitySelect.vue?vue&type=script&lang=js&"
export * from "./CitySelect.vue?vue&type=script&lang=js&"
import style0 from "./CitySelect.vue?vue&type=style&index=0&id=a15605c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15605c2",
  null
  
)

export default component.exports